export default "__VITE_ASSET__Dn1LekMG__"